import { memo } from 'react';
import { EditableCell } from './EditableCell';
import { ProjectDateCellContent } from './ProjectDateCellContent';
import type { Project } from '@/api/client';
import { REVIEW_TABLE_CELL_EMPTY } from '@/utils/reviewCheckType';
import { getBaseStatus } from '@/utils/projectStatuses';

interface ReviewDeadlineCellProps {
  project: Project;
  searchHighlightWords?: string[];
}

const EmptyValue = () => <span className="projects-table__empty-value">{REVIEW_TABLE_CELL_EMPTY}</span>;

export const ReviewDeadlineCell = memo(function ReviewDeadlineCell({
  project,
  searchHighlightWords,
}: ReviewDeadlineCellProps) {
  const hasData = project.review_deadline?.trim();
  const display = hasData ? (
    <ProjectDateCellContent
      dateStr={project.review_deadline}
      isCompleted={getBaseStatus(project.state) === 'Готов'}
      todayLabel="Проверка сегодня"
      containerClassName="projects-table__deadline-cell"
      searchHighlightWords={searchHighlightWords}
    />
  ) : (
    <EmptyValue />
  );

  return (
    <EditableCell project={project} fieldKey="review_deadline">
      {display}
    </EditableCell>
  );
});
